import {createAsyncThunk} from "@reduxjs/toolkit";
import {buildAsyncThunk} from "../../shared/lib/redux";
import * as api from "../../shared/api/templates";

export const fetchAllTemplates = buildAsyncThunk("templates/fetchAll", api.getAllTemplates);
export const fetchTemplatesByType = buildAsyncThunk("templates/fetchByType", api.getTemplatesByType);
export const fetchTemplateById = buildAsyncThunk("templates/fetchById", api.getTemplateById);
export const createTemplate = buildAsyncThunk("templates/create", api.createTemplate);

export const updateTemplate = createAsyncThunk(
    "templates/update",
    async({id, data}, {rejectWithValue}) => {
        try {
            const result = await api.updateTemplate(id, data);
            return result;
        } catch ({response}) {
            const {status, data: errorData} = response;
            const error = {
                status,
                message: errorData.message,
            }
            return rejectWithValue(error);
        }
    }
);

export const deleteTemplate = createAsyncThunk(
    "templates/delete",
    async(id, {rejectWithValue}) => {
        try {
            const result = await api.deleteTemplate(id);
            return {_id: id, ...result};
        } catch ({response}) {
            const {status, data: errorData} = response;
            const error = {
                status,
                message: errorData.message,
            }
            return rejectWithValue(error);
        }
    }
);

